import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, className = "", testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (e2) {
      toast.error("Upload failed", { description: formatApiError(e2) });
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className={className}>
      <div
        className="relative rounded-md border border-dashed border-brand-line hover:border-brand-crimson/60 bg-brand-obsidian overflow-hidden transition-colors cursor-pointer group"
        onClick={() => ref.current?.click()}
        data-testid={testid}
      >
        {value ? (
          <img src={value} alt="Preview" className="h-36 w-full object-cover" data-testid={`${testid}-preview`} />
        ) : (
          <div className="h-36 flex flex-col items-center justify-center gap-2 text-white/40">
            <ImagePlus className="h-7 w-7" />
            <span className="text-xs">Click to upload an image</span>
          </div>
        )}
        {busy && (
          <div className="absolute inset-0 bg-obsidian/70 flex items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-brand-crimson" />
          </div>
        )}
        {value && !busy && (
          <div className="absolute inset-0 bg-obsidian/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-xs text-white font-eyebrow uppercase tracking-[0.2em]">
            Replace image
          </div>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
